import { Route } from 'react-router-dom';
import { RequireAuth } from '../../../common/SharedComponents';
import { BorrowerLendingLimits } from '../../../lendinglimits/BorrowerLendingLimits';
import { LendingLimitDevHarness } from '../../../lendinglimits/devHarness/LendingLimitDevHarness';
import { HarnessGuide } from '../../../lendinglimits/devHarness/HarnessGuide';

export default function LendingLimitRoutes() {
    return (
        <>
            <Route
                path='/borrowerlendinglimit'
                element={
                    <RequireAuth>
                        <div className='est-outer-admin'>
                            <BorrowerLendingLimits />
                        </div>
                    </RequireAuth>
                }
            />
            {/* Dev/QA-only calc verification harness — not linked in nav. */}
            {/* <Route
                path='/borrowerlendinglimit/test-harness'
                element={
                    <RequireAuth>
                        <div className='est-outer-admin'>
                            <LendingLimitDevHarness />
                        </div>
                    </RequireAuth>
                }
            /> */}
            {/* QA/UAT how-to for the harness — behind auth, so not in `public/`. */}
            {/* <Route
                path='/borrowerlendinglimit/test-harness/guide'
                element={
                    <RequireAuth>
                        <div className='est-outer-admin'>
                            <HarnessGuide />
                        </div>
                    </RequireAuth>
                }
            /> */}
        </>
    );
}
